import { writable } from "svelte/store";
import type { PodInfo } from "@antares/shared";

export const pods = writable<PodInfo[]>([]);
export const loading = writable(false);
export const error = writable<string | null>(null);
